// Netcash TwoDay debit orders can't be dated tomorrow: the collection date must be a business day
// at least this many business days away. Public holidays aren't accounted for (no calendar yet).
const MINIMUM_BUSINESS_DAYS_NOTICE = 2;

const pad = (n: number) => String(n).padStart(2, '0');

export const toYmd = (d: Date): string => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const parseYmd = (ymd: string): Date => {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(y, (m ?? 1) - 1, d ?? 1);
};

const isWeekendDate = (d: Date) => d.getDay() === 0 || d.getDay() === 6;

export const isWeekend = (ymd: string): boolean => isWeekendDate(parseYmd(ymd));

export const getEarliestNetcashActionDate = (today: Date = new Date()): string => {
  const d = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  let added = 0;
  while (added < MINIMUM_BUSINESS_DAYS_NOTICE) {
    d.setDate(d.getDate() + 1);
    if (!isWeekendDate(d)) added++;
  }
  return toYmd(d);
};

export const getLastBusinessDayOfMonth = (year: number, month: number): string => {
  const d = new Date(year, month, 0);
  while (isWeekendDate(d)) d.setDate(d.getDate() - 1);
  return toYmd(d);
};

// Last business day of the batch's month, unless that is already too soon to be usable.
export const getDefaultNetcashActionDate = (year: number, month: number): string => {
  const earliest = getEarliestNetcashActionDate();
  const lastBusinessDay = getLastBusinessDayOfMonth(year, month);
  return lastBusinessDay >= earliest ? lastBusinessDay : earliest;
};

export const validateNetcashActionDate = (ymd: string): string | null => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return 'Please choose a collection date.';
  if (isWeekend(ymd)) return 'The collection date must be a business day (Monday to Friday).';

  const earliest = getEarliestNetcashActionDate();
  if (ymd < earliest) {
    return `The collection date must be on or after ${formatActionDate(earliest)} - TwoDay debit orders need at least ${MINIMUM_BUSINESS_DAYS_NOTICE} business days' notice.`;
  }

  return null;
};

export const formatActionDate = (ymd?: string | null): string => {
  if (!ymd) return '-';
  return parseYmd(ymd).toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
};
